import {
  AppBar,
  Box,
  Button,
  Checkbox,
  Container,
  FormControl,
  FormGroup,
  FormHelperText,
  Grid,
  IconButton,
  ListItem,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Paper,
  Select,
  TextField,
  Toolbar,
  Typography,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import React, { useState } from "react";
import useStyles from "./style";
import PesquisaCredito from "../../pages/PesquisaCredito";
import jsondata from "../../test/mock/dinamicComponent";
import MenuIcon from "@mui/icons-material/Menu";
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';

import { useParams } from "react-router-dom";
import { useEffect } from "react";
import PoliticaService from "../../services/politicaService";
import UsuarioService from "../../services/usuarioService";

import { toast } from "react-toastify";
import { Autocomplete } from "@mui/material";
import CurrencyTextField from "@unicef/material-ui-currency-textfield/dist/CurrencyTextField";
const ModalPoliticas = (props) => {
  const classes = useStyles();
  const params = useParams();
  const [empresa, setEmpresa] = useState("");
  const [modelo, setModelo] = useState(null);
  const [politicas, setPoliticas] = useState([]);
  const [valor, setValor] = useState(0.0)
  const [modeloError, setModeloErro] = useState({ isError: false, erroMsg: "" });
  const [politicasAtuais, setPolicasAtuais] = useState([]);

  useEffect(async () => {
    if (props.empresa) {
      setEmpresa(props.empresa);
    }

    if (props.politica){
      setModelo(props.politica.modelo)
      setValor(props.politica.valor)
    } else {
      let response = await PoliticaService.buscarTodas().then((data) => {
        let intersectPoliticas = data.politicas
        if (props.politicasAtuais.length > 0) {
          intersectPoliticas = data.politicas.filter(a => false == props.politicasAtuais.some( b => a.id == b.modelo.id ))
        } 
        
        setPoliticas(intersectPoliticas);
      });
    }
  }, []);

  const adicionar = () => {
    if (modelo != null){
      const politica = {
        "empresa": {
          "id": parseInt(props.empresaId),
        },
        "modelo": {
          "id": modelo.id
        },
        "valor": parseFloat(valor.toString().replace(",", "."))
      }

      if (props.politica != undefined) {
        politica["id"] = parseInt(props.politica.id)
        PoliticaService.editarPolitica(politica).then((data) => {
          toast.success("Política Atualizada com Sucesso!", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          props.fecharModal();
          props.buscarPoliticas(params.id);
        }).catch((err) => {
          toast.error(err.detail, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        })
      } else {
        PoliticaService.adicionarPolitica(politica).then((data) => {
          toast.success("Política Adicionada com Sucesso!", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          props.fecharModal();
          props.buscarPoliticas(params.id);
        }).catch((err) => {
          toast.error(err.detail, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        })
      }
    } else {
      setModeloErro({ isError: true, erroMsg: "Selecione uma política" })
    }
  }

  const getLabelPolitica = (politica) =>
      politica ? politica.nome_consulta.toUpperCase() : "";

  const handlePick = (e, v) => {
      setModelo(v);
  };

  return (
    <Paper className={classes.card}>
      <div>
        <Box sx={{ flexGrow: 1 }}>
          <AppBar
            position="static"
            color="default"
            style={{ borderRadius: "1rem 1rem 0 0" }}
          >
            <Container>
              <Toolbar>
                <Typography
                  variant="h6"
                  color="inherit"
                  className={classes.grow}
                  style={{ flex: 1 }}
                >
                  Adicionar Política 
                </Typography>
                <IconButton onClick={props.fecharModal} aria-label="info">
                  <CloseIcon style={{ width: "32px", marginBottom: "1px" }} />
                </IconButton>
              </Toolbar>
            </Container>
          </AppBar>
        </Box>
        <Grid className={`${classes.root} ${classes.scroll}`}>
          <Container>
            <Box component={"div"} my={8}>
              <Grid
                container
                item
                justifyContent="flex-start"
                alignItems="center"
                md={7}
                xs={12}
              ></Grid>
        
              <Grid container className={classes.margin}>
                <Grid item xs={12}>
                  <Grid container spacing={3} alignItems="baseline">
                    
                    <Grid item xs={12}>
                    <div className={classes.margin}>
                    <FormControl
                              variant="outlined"
                              size="small"
                              fullWidth
                              error={modeloError.isError}
                          >
                      <Autocomplete
                        disabled={props.politica != undefined}
                        size="small"
                        variant="outlined"
                        options={politicas}
                        value={modelo}
                        onChange={handlePick}
                        getOptionLabel={(option) => option.nome_consulta.toUpperCase() || ""}
                        getOptionDisabled={false}
                        renderOption={(props, politica) => {
                          return (
                              <ListItem
                                  key={politica.id}
                                  // style={getListItemStyle(empresa.id)}
                                  onClick={() => setModelo(politica)}
                              >
                                  <ListItemIcon>
                                      <AccountBalanceWalletIcon color="primary" />
                                  </ListItemIcon>
                                  <ListItemText>
                                      {getLabelPolitica(politica)}
                                  </ListItemText>
                              </ListItem>
                          );
                      }}
                      renderInput={(params) => (
                          <TextField error={modeloError.isError} {...params} label="Politicas..." />
                      )}
                  />
                  <FormHelperText>
                    {modeloError.erroMsg}
                  </FormHelperText>
                  </FormControl>
                  </div>
                    </Grid>
                    <Grid item md={9} xs={12}>
                      
                        <TextField
                          disabled
                          size="small"
                          label="Empresa"
                          variant="outlined"
                          type="text"
                          fullWidth={true}
                          value={props.empresa}
                          // onChange={(e) => checkEmailMask(e.target.value)}
                        />
                      
                    </Grid>
                    <Grid item md={3} xs={12}>
                      <FormControl
                              variant="outlined"
                              size="small"
                              fullWidth
                          >
                      <CurrencyTextField
                        // error={!!props.field.required && !value}
                        // id={props.field.id}
                        label="Valor"
                        placeholder="0,00"
                        variant="outlined"
                        size="small"
                        value={valor}
                        currencySymbol="R$"
                        minimumValue="0"
                        outputFormat="string"
                        decimalCharacter=","
                        digitGroupSeparator="."
                        onChange={(e) =>
                          setValor(e.target.value)
                        }
                      />
                    </FormControl>
                    </Grid>
                  </Grid>
                  <Box marginTop="2rem" width="80rem" maxWidth="95vw">
                  {props.politica != undefined ? (
                      <Button
                        onClick={adicionar}
                        type="submit"
                        variant="contained"
                        color="primary"
                      >
                        Atualizar
                      </Button>
                    ) : (
                    <Button
                        onClick={adicionar}
                        type="submit"
                        variant="contained"
                        color="primary"
                      >
                        Adicionar
                    </Button>
                    )}
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Container>
        </Grid>
      </div>
    </Paper>
  );
};

export default ModalPoliticas;
